import {SListTabs} from "shj-components";
import Dept from "@/pages/targetConfig/objectiveManage/component/Dept";
import React from "react";
import Company from "@/pages/targetConfig/objectiveManage/component/Company";
import Personal from "@/pages/targetConfig/objectiveManage/component/Personal";
import AchievementDate from "@/pages/targetConfig/achievementDate";
import Armed from "@/pages/targetConfig/objectiveManage/component/Armed";
import {getAuth} from "@/utils/auth.ts";

const TargetConfig = () => {

  const items = [
    {
      key: 'service',
      label: '军种',
      children: <Armed/>,
      auth: 'serviceTab'
    },
    {
      key: 'company',
      label: '分公司',
      children: <Company />,
      auth: 'companyTab'
    },
    {
      key: 'dept',
      label: '部门',
      children: <Dept />,
      auth: 'deptTab'
    },
    {
      key: 'personal',
      label: '个人',
      children: <Personal />,
      auth: 'personalTab'
    },
    {
      key: 'achievement',
      label: '业绩期配置',
      children: <AchievementDate/>,
      auth: 'achievementTab'
    },
  ]

  return <SListTabs items={items} hideExtra={true} auth={getAuth()} />
}

export default TargetConfig